import DOMPurify from 'dompurify';
import './SafeHtml.css';

export default function SafeHtml({ value, as: Element = 'div', inline = false, className = '' }) {
  const options = inline ? {
    ALLOWED_TAGS: ['mark', 'b', 'strong', 'i', 'em', 'u', 's', 'br', 'span', 'sub', 'sup', 'small', 'code'],
    ALLOWED_ATTR: ['class', 'lang', 'dir'],
  } : {};
  return <Element className={`api-html ${className}`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(String(value || ''), options) }} />;
}
